export default __webpack_public_path__ + "static/1089-668f4d56e7eece9da2f2790db819309a.gif";